import React, { FC, ReactElement, ReactNode } from 'react'
import { DeepMap, FieldError, useFormContext, UseFormMethods } from '../../../../Vendor/react-hook-form/dist/index.ie11'
import { IsStringEmpty, isVarNotEmpty } from '../../../../NonReact/utils/GlobalFunctions'
import { EMPTY_STRING } from '../../Constants/Separators'

type Props = {
    className?: string
    name: string
    children?: ReactNode
}

const getValidationMessage = (error: Nullable<FieldError>): Nullable<ReactElement> =>
    error && <div className='vc-message'>{error?.message}</div>

// eslint-disable-next-line
export const getFieldError = (name: string, errors: DeepMap<Record<string, any>, FieldError>): Nullable<FieldError> => {
    const splitNames: string[] = name.split(/\.|\[|\]/g).filter((entry: string): boolean => !IsStringEmpty(entry))
    const errorObj: Nullable<FieldError> = splitNames?.reduce(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (accum, next: string) => (accum ? accum[next] : undefined),
        errors
    ) as FieldError

    return errorObj
}

/**
 * Validation Errors wrapper.
 *
 * @param className - The class name of the component.
 * @param name - The name of the component.
 * @param children - The wrapped component.
 */
export const ValidationErrors: FC<Props> = ({ className, name, children }: Props): ReactElement => {
    const { errors }: UseFormMethods = useFormContext()

    const fieldError: Nullable<FieldError> = getFieldError(name, errors)

    return (
        <div className={`validation-container ${isVarNotEmpty(fieldError) ? 'vc-error' : EMPTY_STRING} ${className}`}>
            {children ? <div className='vc-field'>{children}</div> : <></>}
            {getValidationMessage(fieldError)}
        </div>
    )
}
